import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { BookOpen, ShieldWarning, Question, Exam, ChartBar, SignOut } from "@phosphor-icons/react";

const links = [
  { to: "/learn", label: "Learn", icon: BookOpen, testid: "nav-learn" },
  { to: "/guide", label: "Avoid Phishing", icon: ShieldWarning, testid: "nav-guide" },
  { to: "/faq", label: "Q&A", icon: Question, testid: "nav-faq" },
  { to: "/test", label: "Take the Test", icon: Exam, testid: "nav-test" },
  { to: "/my-results", label: "My Results", icon: ChartBar, testid: "nav-my-results" },
];

export default function StaffLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-40 bg-white/95 backdrop-blur-md border-b border-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 h-16 flex items-center justify-between gap-4">
          <div className="flex items-center gap-3 shrink-0">
            <img src="/mcr-logo.png" alt="Mobile Crisis 24/7 Services" className="h-8 sm:h-9 w-auto" />
            <div className="hidden sm:block border-l border-border pl-3 leading-tight">
              <p className="text-[11px] uppercase tracking-[0.15em] text-muted-foreground font-semibold">Cyber Security</p>
              <p className="text-[11px] uppercase tracking-[0.15em] text-primary font-semibold">Training</p>
            </div>
          </div>

          <nav className="hidden md:flex items-center gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={l.testid}
                className={({ isActive }) =>
                  `flex items-center gap-2 px-3.5 py-2 rounded-full text-sm font-medium transition-colors duration-200 ${
                    isActive ? "bg-primary text-white" : "text-primary hover:bg-muted"
                  }`
                }
              >
                <l.icon size={18} weight="duotone" />
                {l.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-3 shrink-0">
            <span className="hidden sm:block text-sm text-muted-foreground max-w-[140px] truncate" data-testid="staff-name">
              {user?.name}
            </span>
            <button
              onClick={handleLogout}
              data-testid="logout-button"
              className="flex items-center gap-1.5 text-sm text-primary hover:text-accent transition-colors duration-200 font-medium"
            >
              <SignOut size={18} weight="duotone" /> Log out
            </button>
          </div>
        </div>

        <nav className="md:hidden flex items-center gap-1 px-2 pb-2 overflow-x-auto border-t border-border/60">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) =>
                `flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap ${
                  isActive ? "bg-primary text-white" : "text-primary"
                }`
              }
            >
              <l.icon size={15} weight="duotone" />
              {l.label}
            </NavLink>
          ))}
        </nav>
      </header>

      <main>
        <Outlet />
      </main>
    </div>
  );
}
